module.exports = __webpack_public_path__ + "img/f_05.ef3f5b7.png";